import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const howlerbrosSize = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '28',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '40',
  '30/32',
  '31/32',
  '32/32',
  '33/32',
  '34/32',
  '35/32',
  '36/32',
  '38/32',
  '40/32',
  'ONE SIZE',
];

export const howlerbrosShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: howlerbrosSize }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '0a5153a6bda248acb7bcf19d390bcd24',
      [BuilderSections.TopbarContent]: '476af329cd0347eabaf7207c3dc6416c',
      [BuilderSections.ListingCardDetails]: 'de74ebe615914496982af4ef075ef65e',
      [BuilderSections.SubscribeFormFooterContent]: '9353855d10eb4da5af85d81e438cb7a4',
    },
  },
};
